export const AppDeviceCookieName = "AppDevice";

export enum AppDevice {
  IOS = "iOS",
  APK = "Android APK",
  ANDROID_GOOGLE_PLAY = "Android Google Play",
}

/**
 * Get the device code from the device name
 * @param device
 * @returns
 */
export function getAppDeviceCode(device?: AppDevice) {
  if (device === AppDevice.IOS) {
    return 1;
  } else if (device === AppDevice.APK) {
    return 2;
  } else if (device === AppDevice.ANDROID_GOOGLE_PLAY) {
    return 3;
  } else {
    return 0;
  }
}
